/** Class joining. Small enough not to warrant a dependency. */
export function cn(...values: readonly (string | false | null | undefined)[]): string {
  return values.filter((value): value is string => typeof value === 'string' && value.length > 0).join(' ');
}
